import { Divider, Grid } from '@mui/material';
import { ContainerImg } from '../../main/style';
import Regi1 from '../../../../assets/img/register1.png';
import Regi2 from '../../../../assets/img/register2.png';
import './style.css';
import { SubmitButton } from '../../../../components';
import { ContainerBackgroundImage } from './style';

// eslint-disable-next-line react/prop-types
export default function SectionRegister({ onClickVenue, onClickVendor }) {
  return (
    <Grid container>
      <ContainerBackgroundImage>
        <Grid item xs={12}>
          <Grid container style={{ marginTop: '100px' }}>
            <Grid className="tittle" item xs={12}>
              REGISTER
            </Grid>
            <Grid item xs={1.5} />
            <Grid item xs={4}>
              <ContainerImg className="image" src={Regi1} />
              <SubmitButton className="button-joinvenue" onClick={onClickVendor}>
                Join as a Vendor
              </SubmitButton>
            </Grid>
            <Grid item xs={0.5}>
              <Divider orientation="vertical" />
            </Grid>
            <Grid item xs={0.5} />
            <Grid item xs={4}>
              <ContainerImg className="image" src={Regi2} />
              <SubmitButton className="button-joinvendor" onClick={onClickVenue}>
                Join as a Venue
              </SubmitButton>
            </Grid>
            <Grid item xs={1.5} />
          </Grid>
        </Grid>
      </ContainerBackgroundImage>
    </Grid>
  );
}
